module.exports = __webpack_public_path__ + "img/banner2.505ddcc4.jpg";